import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PageLinksListComponent} from './page-links-list/page-links-list.component';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {FilterPipeModule} from 'ngx-filter-pipe';
import { FormLinksComponent } from './form-links/form-links.component';
import { SvgComponent } from '@inspark/inspark-components';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule, FilterPipeModule, SvgComponent],
  declarations: [PageLinksListComponent, FormLinksComponent],
  exports: [PageLinksListComponent, FormLinksComponent],
})
export class PageLinksModule {}
